import React from 'react'
import {t} from '../helpers/translate.js'

let config = require('config');

class AgentProducts extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
    	<div className="container">
        <h2 className="page-title text-center">{t('All Products')}</h2>
    		<iframe 
    			className='product-iframe'
    			src={`${config.default.agent_portal}/login/en/travel-insurance/agent-products/${sessionStorage.getItem('csr_token')}`} 
			/>
		</div>
    )
  }
}
AgentProducts.displayName = 'AgentProducts';
export default AgentProducts;



// WEBPACK FOOTER //
// ./src/components/AgentProducts.js